// extracted by mini-css-extract-plugin
export var body = "_m8-0";
export var sectionHeader = "_m8-4";
export var shortcutColumns = "_m8-2";
export var shortcutList = "_m8-1";
export var shortcutSection = "_m8-3";